import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-smart-poultry-info-legal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './smart-poultry-info-legal.component.html',
    styleUrl: './smart-poultry-info-legal.component.scss'
})
export class SmartPoultryInfoLegalComponent implements OnInit {
    public currentYear: number = new Date().getFullYear();

    // SmartPoultry Information
    public smartPoultryInfo = {
        name: 'SmartPoultry',
        tagline: 'Intelligent Poultry Farm Management System',
        supportEmail: 'support@smartpoultary.ai',
        website: 'https://smartpoultary.ai',
        description:
            'The smart poultry management system: is an advanced AI-driven solution designed to streamline and automate various operations within poultry farms.'
    };

    public legalDocuments = [
        {
            id: 'terms',
            title: 'Terms & Conditions',
            fileName: 'Smart_Poultry_Terms_and_Conditions.pdf',
            filePath: 'assets/docs/Smart_Poultry_Terms_and_Conditions.pdf',
            description:
                'Read our terms and conditions for using SmartPoultry services.',
            icon: 'fas fa-file-contract'
        },
        {
            id: 'privacy',
            title: 'Privacy Policy',
            fileName: 'Smart_Poultry_Privacy_Policy.pdf',
            filePath: 'assets/docs/Smart_Poultry_Privacy_Policy.pdf',
            description: 'Learn how we collect, use, and protect your data.',
            icon: 'fas fa-shield-alt'
        },
        {
            id: 'eula',
            title: 'End User License Agreement (EULA)',
            fileName: 'Smart_Poultry_EULA_Final.pdf',
            filePath: 'assets/docs/Smart_Poultry_EULA_Final.pdf',
            description:
                'Review the license agreement for SmartPoultry software.',
            icon: 'fas fa-file-signature'
        }
    ];

    constructor() {}

    ngOnInit(): void {
        // Component initialization
    }

    viewDocument(document: any): void {
        window.open(document.filePath, '_blank');
    }

    downloadDocument(doc: any): void {
        const link = document.createElement('a');
        link.href = doc.filePath;
        link.download = doc.fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    formatDate(date: Date): string {
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).format(date);
    }
}
